import { render, staticRenderFns } from "./ProductDetailHaven.vue?vue&type=template&id=5be7ea41&scoped=true&"
import script from "./ProductDetailHaven.ts?vue&type=script&lang=ts&"
export * from "./ProductDetailHaven.ts?vue&type=script&lang=ts&"
import style0 from "./ProductDetailHaven.vue?vue&type=style&index=0&id=5be7ea41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7ea41",
  null
  
)

export default component.exports